module.exports = __webpack_public_path__ + "img/red.67f85aba.jpg";